module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("icIuP"))).then(() => parcelRequire('3a9aZ'));